import { Container } from '@hover/blueprint';
import React from 'react';
import Desktop from './Desktop';
import Mobile from './Mobile';

const RenderingsPersonalized: React.FC = () => (
  <Container maxW="1200px" px={500} mb={1100}>
    <Desktop />
    <Mobile />
  </Container>
);

export default RenderingsPersonalized;
